import FileSelectedPanelContainer from './FileSelectedPanelContainer';

export default FileSelectedPanelContainer;